// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"87e0eef0","693":"4fe2501b"}[chunkId] + ".chunk.js";
};